export function Skeleton({ className = "", testid }) {
  return (
    <div
      data-testid={testid}
      className={`bg-[#15151B] animate-pulse ${className}`}
    />
  );
}

export function CardSkeleton() {
  return (
    <div className="card-surface p-6 space-y-4" data-testid="card-skeleton">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-8 w-32" />
      <Skeleton className="h-3 w-40" />
    </div>
  );
}

export function RowSkeleton({ count = 4 }) {
  return (
    <div className="card-surface divide-y divide-[#272730]">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="p-5 flex items-center gap-4">
          <Skeleton className="h-10 w-10 shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
          </div>
          <Skeleton className="h-6 w-16 shrink-0" />
        </div>
      ))}
    </div>
  );
}

export function GridSkeleton({ count = 9 }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#272730] border border-[#272730]">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-[#0F0F12] p-5 space-y-3">
          <div className="flex justify-between">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-16" />
          </div>
          <Skeleton className="h-5 w-2/3" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-12 w-full" />
        </div>
      ))}
    </div>
  );
}

export function PageSpinner({ label = "Loading…" }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3 text-[#71717A] font-mono text-sm">
      <div className="w-6 h-6 border-2 border-[#272730] border-t-[#FF4A11] rounded-full animate-spin" />
      <span>{label}</span>
    </div>
  );
}
